import { render, staticRenderFns } from "./DataPictogramComponent.vue?vue&type=template&id=78f4c1f2&scoped=true"
import script from "./DataPictogramComponent.vue?vue&type=script&lang=js"
export * from "./DataPictogramComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4c1f2",
  null
  
)

export default component.exports